module.exports = __webpack_public_path__ + "media/images/stock_groups/e894-a33162b53710e40158251b731fe13943.svg";